import { ActivityIndicator, Pressable, Text } from 'react-native'
import type { ComponentType } from 'react'
import type { LucideProps } from 'lucide-react-native'
import { colors } from '@chillout/core'

interface NumpadKeyProps {
  digit?: string
  Icon?: ComponentType<LucideProps>
  iconColor?: string
  onPress: () => void
  disabled?: boolean
  loading?: boolean
  accessibilityLabel: string
}

export function NumpadKey({
  digit,
  Icon,
  iconColor = colors.text.primary,
  onPress,
  disabled = false,
  loading = false,
  accessibilityLabel,
}: NumpadKeyProps) {
  const isDisabled = disabled || loading

  return (
    <Pressable
      onPress={onPress}
      disabled={isDisabled}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      accessibilityState={{ disabled: isDisabled, busy: loading }}
      className={`flex-1 items-center justify-center rounded-lg border border-border py-6 active:bg-border ${isDisabled ? 'opacity-30' : ''}`}
    >
      {loading ? (
        <ActivityIndicator size="small" color={colors.text.muted} />
      ) : Icon ? (
        <Icon size={24} color={iconColor} strokeWidth={2} />
      ) : (
        <Text className="text-2xl font-medium text-primary">{digit}</Text>
      )}
    </Pressable>
  )
}
